export function flashEffect(documentQuery: string): void {
  const flashDiv = document.querySelector<HTMLElement>(documentQuery)
  if (flashDiv) {
    flashDiv.style.display = 'block'
    flashDiv.style.opacity = '1'
    setTimeout(() => {
      flashDiv.style.transition = 'opacity 0.3s'
      flashDiv.style.opacity = '0.5'
      setTimeout(() => {
        flashDiv.style.transition = 'opacity 0.3s'
        flashDiv.style.opacity = '0'
        setTimeout(() => {
          flashDiv.style.display = 'none'
          flashDiv.style.opacity = '1' // Reset opacity
        }, 300)
      }, 300)
    }, 0)
  }
}
